var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"processingModal",attrs:{"id":"processingModal","hide-header":"","hide-footer":"","visible":_vm.isProcessing}},[_c('h4',{staticClass:"text-center mt-4 bb-4"},[_vm._v(_vm._s(_vm.$t('global.processingRequest')))]),_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }